import CustomButton from './Button';
import EyeIcon from '../assets/eye.png';
import DownloadIcon from '../assets/download.png';
import UploadIcon from '../assets/upload.png';
import { getCreateWith } from '../helpers/createWith';
import { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';

// Extend Window interface to include ReactNativeWebView
declare global {
	interface Window {
		ReactNativeWebView?: {
			postMessage: (message: string) => void;
		};
		displaySketch: any;
	}
}

export type ToolsSaveProps = {
	openPreview: () => void;
};

function ToolsSave({ openPreview }: ToolsSaveProps) {
	const createWith = getCreateWith();
	const dpSketch = () => window.displaySketch; // helper to get the p5 instance of displaySketch
	const [isSaving, setIsSaving] = useState(false);

	const saveCanvasDataToLocalStorage = async () => {
		if (isSaving || !createWith) return; // Prevent double clicks

		try {
			setIsSaving(true);
			const canvasId = dpSketch()?.canvas.id;
			const canvasElement = document.getElementById(canvasId) as HTMLCanvasElement;
			const canvasData = canvasElement.toDataURL('image/png');

			// Use createWith.local_save method
			await createWith.local_save(canvasData);
		} catch (error: any) {
			console.error(error);
			alert('Error saving image to local device.');
		} finally {
			setIsSaving(false);
		}
	};

	// Uses the dpSketch canvas to save an image to the online server
	const saveCanvasMobile = async () => {
		if (isSaving || !createWith) return; // Prevent double clicks

		const canvasId = dpSketch()?.canvas.id;
		const canvasElement = document.getElementById(canvasId) as HTMLCanvasElement;
		const canvasData = canvasElement.toDataURL('image/png');

		try {
			setIsSaving(true);
			await createWith.post(canvasData);
			createWith.close();
		} catch (error: any) {
			console.error(error);
			alert(`Error saving image: \n ${error.message}`);
		} finally {
			setIsSaving(false);
		}
	};

	if (isSaving) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" width="100%">
				<CircularProgress color="primary" />
			</Box>
		);
	}

	return (
		<>
			<CustomButton onClick={saveCanvasDataToLocalStorage} image={DownloadIcon} label="Local Device" imageSize={33} imagePadding={2} />
			<CustomButton onClick={saveCanvasMobile} image={UploadIcon} label="ONLINE" imageSize={33} imagePadding={2} />
			<CustomButton onClick={openPreview} image={EyeIcon} label="PREVIEW" imageSize={33} imagePadding={2} />
		</>
	);
}

export default ToolsSave;
